export const LIMITED_ACCESS = 'limitedAccess';
export const NO_ACCESS = 'noAccess';
export const API_LIMITED_ACCESS = 'LIMITED_ACCESS';
export const API_NO_ACCESS = 'NO_ACCESS';
export const API_FULL_ACCESS = 'FULL_ACCESS';